<script setup>
import { ref, watch } from 'vue'
import ModalDialog from './ModalDialog.vue'

const props = defineProps({ open: Boolean, sale: { type: Object, default: null }, pending: Boolean, error: { type: String, default: '' } })
const emit = defineEmits(['close', 'confirm'])
const reason = ref('')
const validationError = ref('')
watch(() => props.open, () => { reason.value = ''; validationError.value = '' })
function submit() {
  if (props.pending) return
  validationError.value = reason.value.trim() ? '' : 'Укажите причину отмены продажи.'
  if (!validationError.value) emit('confirm', reason.value.trim())
}
</script>

<template>
  <ModalDialog :open="open" :title="`Отменить продажу №${sale?.id || ''}?`" eyebrow="Без удаления истории" @close="!pending && emit('close')">
    <form class="dialog-form" @submit.prevent="submit">
      <p class="cancel-help">Товары вернутся на склад. Продажа, её состав, цена, автор и причина отмены останутся в истории.</p>
      <label class="field"><span>Причина отмены <b aria-hidden="true">*</b></span><textarea v-model="reason" rows="3" maxlength="1000" required autofocus /></label>
      <p v-if="validationError || error" class="form-error" role="alert">{{ validationError || error }}</p>
      <footer class="modal-actions">
        <button type="button" class="button button--ghost" :disabled="pending" @click="emit('close')">Не сейчас</button>
        <button type="submit" class="button button--danger" :disabled="pending">{{ pending ? 'Отменяем…' : 'Отменить продажу' }}</button>
      </footer>
    </form>
  </ModalDialog>
</template>

<style scoped>.cancel-help { color: var(--muted); font-size: .8rem; line-height: 1.5; }</style>
